import styled from 'styled-components';

export const StyledFilter = styled.div`
  width: 100%;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  .ant-form-item {
    margin-bottom: 0;
  }
`;
